import { makeObservable, observable, action, computed, runInAction } from 'mobx';

import { SuccessToast, ErrorToast } from 'src/libs/toast';
import CourseService from 'src/services/course';
import CourseError from 'src/services/error/models/course';

import AlertViewModel from 'src/components/Alert/viewModel';

export default class RatingModalViewModel extends AlertViewModel {
  @observable isLoading = true;
  @observable cid;
  @observable id;

  @observable score = 0;
  @observable title = '';
  @observable comment = '';

  @observable scoreCache = 0;
  @observable titleCache = '';
  @observable commentCache = '';

  @observable isProcessing = false;

  constructor(props) {
    super(props);
    makeObservable(this);
  }

  handlerBackgroundCloseAlert = () => { }

  @action
  updateData = (data) => {
    this.cid = data.cid;
    this.id = data.id ?? null;
    this.score = data.score ?? 0;
    this.title = data.title ?? '';
    this.comment = data.comment ?? '';

    this.cacheHandler('clone');
  }

  @action
  handleConfirm = async (handleModalConfirm) => {
    try {
      this.isProcessing = true;
      const data = {
        score: this.scoreCache,
        title: this.titleCache,
        comment: this.commentCache
      };
      if (!this.id) {
        await CourseService.postRating(this.cid, data);
        runInAction(async () => {
          SuccessToast('新增評分成功');
          await handleModalConfirm();
        });
      } else {
        await CourseService.putRating(this.cid, this.id, data);
        runInAction(async () => {
          SuccessToast('修改評分成功');
          await handleModalConfirm();
        });
      }
      runInAction(() => {
        this.cacheHandler('submit');
        this.handlerCloseAlert();
        this.isProcessing = false;
      });
    } catch (error) {
      console.error(error);
      CourseError.putRating(error);
      this.isProcessing = false;
    }
  }

  @action
  handleClose = () => {
    this.handlerCloseAlert();
    this.cacheHandler('clone');
  }

  @action
  handleInputChange = (e) => {
    this.titleCache = e.target.value;
  }

  @action
  handleCommentChange = (e) => {
    this.commentCache = e.target.value;
  }

  @action
  handleRatingChange = (score) => {
    this.scoreCache = score;
  }

  @action
  handleRatingOpen = (score) => {
    this.handleRatingChange(score);
    this.handlerOpenAlert();
  }

  @action
  cacheHandler = (type) => {
    switch (type) {
      case 'clone':
        this.scoreCache = this.score;
        this.titleCache = this.title;
        this.commentCache = this.comment;
        break;
      case 'submit':
        this.score = this.scoreCache;
        this.title = this.titleCache;
        this.comment = this.commentCache;
        break;
      default:
        throw new Error('no corresponding type');
    }
  }
}
